export var none = {
  toString: function () {
    return "none";
  },
};
